import React from "react"
import bordikBlack from "../../assets/images/bordik_black.svg"
import bordikLight from "../../assets/images/bordik_light.svg"

interface BrandLogoProps {
    variant?: "light" | "dark"
    height?: number
    className?: string
    markOnly?: boolean
}

const BrandLogo: React.FC<BrandLogoProps> = ({variant = "dark", height = 35, className, markOnly}) => {
    const src = variant === "light" ? bordikLight : bordikBlack

    if (markOnly) {
        const width = Math.round(height * 1.05)

        return (
            <svg
                className={className}
                width={width}
                height={height}
                viewBox="0 0 512 487"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-label="Bordik"
                role="img"
            >
                <g transform="translate(0 487) scale(0.1 -0.1)" fill="currentColor">
                    <path d="M3856 4405 c-164 -256 -297 -467 -295 -469 2 -2 38 -18 80 -35 117 -49 231 -124 332 -221 l93 -88 431 491 c273 312 427 494 420 499 -7 3 -174 67 -372 141 -198 75 -367 138 -375 141 -11 5 -91 -113 -314 -459z" />
                    <path d="M2205 4728 c-3 -7 -90 -418 -195 -913 -105 -495 -202 -933 -216 -974 -58 -175 -82 -377 -64 -539 50 -449 342 -775 776 -867 118 -25 330 -23 464 4 473 99 893 447 1092 906 199 462 133 951 -172 1255 -186 187 -425 280 -715 280 -210 0 -399 -47 -603 -149 l-101 -51 53 113 c196 419 429 928 425 931 -2 2 -169 6 -372 10 -294 5 -368 4 -372 -6z m1003 -1344 c501 -102 649 -711 283 -1167 -122 -151 -274 -258 -451 -318 -81 -27 -114 -33 -220 -37 -95 -3 -140 -1 -190 12 -362 91 -546 446 -434 835 131 450 595 760 1012 675z" />
                    <path d="M0 3341 c3 -166 30 -835 35 -839 4 -4 248 -8 543 -10 295 -1 648 -3 783 -5 l246 -2 12 105 c13 121 48 276 86 375 14 37 24 69 23 70 -2 1 -361 68 -798 149 -437 82 -825 154 -862 161 -62 11 -68 11 -68 -4z" />
                    <path d="M4287 2615 c-23 -113 -69 -248 -123 -364 -24 -52 -42 -96 -40 -99 9 -9 891 -219 894 -212 6 15 100 735 96 739 -5 5 -487 19 -684 20 l-125 1 -18 -85z" />
                    <path d="M1594 1384 c-159 -141 -293 -260 -298 -264 -8 -8 500 -640 513 -640 4 0 115 177 249 393 133 215 252 406 263 424 l20 32 -77 35 c-102 48 -224 130 -311 210 l-71 66 -288 -256z" />
                    <path d="M3615 1571 c-24 -39 -282 -188 -410 -237 -47 -17 -59 -26 -57 -41 6 -33 292 -1258 297 -1271 3 -8 135 53 407 189 222 111 404 202 406 204 3 3 -616 1147 -627 1158 -5 5 -12 4 -16 -2z" />
                </g>
            </svg>
        )
    }

    return (
        <img
            src={src}
            alt="Bordik"
            height={height}
            className={className}
            style={{height, width: "auto"}}
        />
    )
}

export default BrandLogo
